import { all } from "redux-saga/effects";
import { AdminSagasCreator } from "@thewebops/admin-panel";

export default function* rootSaga() {
  const adminSagas = AdminSagasCreator();
  const combinedSagas = [...adminSagas].map((saga) => saga());
  yield all(combinedSagas);
}
